import * as React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger } from '../../../../../web/components-v2/Select';
import { CALL_TYPE_OPTIONS, CallTypeFilter } from '../../../../entities/LeadView/useLeadView';
import { styleSheet } from './styles';

interface IProps {
	disabled?: boolean;
	onChange?: (item: CallTypeFilter) => void;
	selected?: CallTypeFilter;
}

export const CallTypeSelect: React.FC<IProps> = ({ disabled, onChange, selected }) => {
	const selectedOption = CALL_TYPE_OPTIONS.find(x => x.value === selected) ?? CALL_TYPE_OPTIONS[0];

	return (
		<Select
			disabled={disabled}
			value={selectedOption.value}
			onValueChange={value => onChange?.(value as CallTypeFilter)}
		>
			<SelectTrigger styles={styleSheet.select}>
				<span>{selectedOption.label}</span>
			</SelectTrigger>
			<SelectContent styles={styleSheet.selectDropdown}>
				{CALL_TYPE_OPTIONS.map(option => (
					<SelectItem key={option.value} value={option.value} styles={styleSheet.selectItem}>
						{option.label}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
};
